/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_PositionInputs */

const th_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตำแหน่ง`)
};

const en_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const ja_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポジション`)
};

const zh_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const es_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición`)
};

const pt_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição`)
};

const id_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi`)
};

const fr_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poste`)
};

const tl_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisyon`)
};

const vi_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vị trí`)
};

const ko_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포지션`)
};

const de_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position`)
};

const ru_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция`)
};

const tr_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozisyon`)
};

const it_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruolo`)
};

const pl_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozycja`)
};

const uk_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиція`)
};

const hi_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थान`)
};

const ar_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المركز`)
};

const ms_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posisi`)
};

const bn_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অবস্থান`)
};

const zh_tw2_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const zh_hk2_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const ur_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پوزیشن`)
};

const fa_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پست`)
};

const sw_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nafasi`)
};

const nl_player_position = /** @type {(inputs: Player_PositionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positie`)
};

/**
* | output |
* | --- |
* | "Position" |
*
* @param {Player_PositionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_position = /** @type {((inputs?: Player_PositionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_PositionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_position(inputs)
	if (locale === "ja") return ja_player_position(inputs)
	if (locale === "zh") return zh_player_position(inputs)
	if (locale === "es") return es_player_position(inputs)
	if (locale === "pt") return pt_player_position(inputs)
	if (locale === "id") return id_player_position(inputs)
	if (locale === "fr") return fr_player_position(inputs)
	if (locale === "tl") return tl_player_position(inputs)
	if (locale === "vi") return vi_player_position(inputs)
	if (locale === "ko") return ko_player_position(inputs)
	if (locale === "de") return de_player_position(inputs)
	if (locale === "ru") return ru_player_position(inputs)
	if (locale === "tr") return tr_player_position(inputs)
	if (locale === "it") return it_player_position(inputs)
	if (locale === "pl") return pl_player_position(inputs)
	if (locale === "uk") return uk_player_position(inputs)
	if (locale === "hi") return hi_player_position(inputs)
	if (locale === "ar") return ar_player_position(inputs)
	if (locale === "ms") return ms_player_position(inputs)
	if (locale === "bn") return bn_player_position(inputs)
	if (locale === "zh-TW") return zh_tw2_player_position(inputs)
	if (locale === "zh-HK") return zh_hk2_player_position(inputs)
	if (locale === "ur") return ur_player_position(inputs)
	if (locale === "fa") return fa_player_position(inputs)
	if (locale === "sw") return sw_player_position(inputs)
	if (locale === "nl") return nl_player_position(inputs)
	return en_player_position(inputs)
});